import React, { Component } from 'react';
import { connect } from "react-redux";
import {BrowserRouter, Route, Routes, useLocation, useNavigate} from "react-router-dom";
import {QueryParamProvider} from "use-query-params";
import {ToastContainer} from "react-toastify";
import Login from "./Login";
import Signup from "./Signup";
import Installation from "../welcome/Installation";
import  '../../style/authentication.scss';


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class Authentication extends Component {

    constructor(props) {
        super(props);

    }


    render() {
        const { t } = this.props;
        return (


                <BrowserRouter>
                    <QueryParamProvider ReactRouterRoute={RouteAdapter}>
                        <React.Fragment>
                            <ToastContainer
                                position="top-center"
                                autoClose={5000}
                                hideProgressBar={false}
                                newestOnTop
                                closeOnClick
                                rtl={false}
                                pauseOnFocusLoss
                                draggable
                                pauseOnHover
                            />
                            <Routes>
                                <Route path={"/login"}
                                       element={<Login/>}/>
                                <Route path={ "/signup"}
                                       element={<Signup/>}/>
                                <Route path={"/welcome/installation"}
                                       element={<Installation/>}/>
                                <Route path="*"
                                       element={<Login/>}/>
                            </Routes>
                        </React.Fragment>
                    </QueryParamProvider>
                </BrowserRouter>


        );
    }
}
const RouteAdapter = ({ children }) => {
    const navigate = useNavigate();
    const location = useLocation();

    const adaptedHistory = React.useMemo(
        () => ({
            replace(location) {
                navigate(location, { replace: true, state: location.state });
            },
            push(location) {
                navigate(location, { replace: false, state: location.state });
            },
        }),
        [navigate]
    );
    return children({ history: adaptedHistory, location });
};
export default Authentication;
